export enum CommunityPathParams {
    LANGUAGE = "lang",
    CONTENT = "content",
    CHAT = "chat",
    CONTENT_STORAGE = "contentComm",
    SETTINGS = "website/settings",

    // Backlinks
    BACKLINKS = "authority",
    BACKLINKS_OVERVIEW = "authority/overview",
    BACKLINKS_CAMPAIGNS = "authority/campaigns",
    CAMPAIGN = "campaign",

    // Social
    SOCIAL = "social",
    POST = "post",
    INBOX = "inbox",

    // Reports
    REPORTS = "reports",
    BUILDER = "builder",
    REPORT = "report",

    // Site web
    BLOG = "website",
    BLOG_CONNECT = "website/connect",
    BLOG_GSC = "website/connect",
    BLOG_PARTNER = "website/connect",
    AI_STYLE = "brand/writing",
    BLOG_IMAGE_STYLE = "brand/image-style",
    BLOG_CTA = "brand/cta",

    // Votre marque
    BRAND = "brand",
    BRAND_DOCUMENTS = "brand/documents",

    // Création
    CREATE = "creation/create",
    BLOGS_POSTS = "creation/contents",
    // le calendrier éditorial vit dans l'onglet des thématiques, à côté de la liste. Le chemin
    // portait deux segments de plus (m/calendar) qui visaient un sous-routeur retiré depuis : ils
    // n'étaient lus par personne et ce chemin menait déjà exactement ici
    CONTENT_AUTOPILOT = "creation/topics",
    CONTENT_CLUSTERS = "creation/topics",
    CONTENT_KEYWORDS = "creation/keywords",

    // Optimisation
    OPTIMIZE = "optimization/optimize",
    OPTIMIZATION_CANNIBALIZATION = "optimization/cannibalization",
    CONTENT_AUDIT = "optimization/tracking",
    INDEXING = "optimization/indexing",
    INDEXING_DELISTED = "optimization/indexing/view/delisted",

    TECH = "tech",
    TECH_INDEXATION = "tech/indexation",
    TECH_AUDIT = "tech/seoaudit",
    TECH_ALT = "tech/altimages",

    // Competitors
    COMPETITORS = "competitors",

    // Visibilité IA
    LLM = "llm",

    // Bibliothèque Louise
    LIBRARY = "library",

    // Analytics
    ANALYTICS = "analytics",

    // Audit
    AUDIT = "audit",
    AUDIT_SEO = "audit/seoaudit",
    POSITION = "audit/keywords",

    // Tools
    TOOLS = "tools",
    TOOLS_KEYWORDS = "tools/keywords",

    // Compte
    ACCOUNT = "account",
    SUBSCRIPTIONS = "subscriptions",
    SUBSCRIPTIONS_INVOICES = "subscriptions/invoices",
    SUBSCRIPTIONS_PAYMENT = "subscriptions/payment",
    SUBSCRIPTIONS_ADDRESS = "subscriptions/address",
    INVITATIONS = "invitations",
    ROLES = "roles",
    MEMBERS = "members",
    REFERRALS = "referrals",

    // Options site
    WEBSITE_SETTINGS = "website/settings",
    HELPCENTER = "helpcenter",

    // White label
    WHITE_LABEL = "whitelabel",

    // API
    API = "api",
}